var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgEmpty = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_682_671)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.01374 19.351C4.84865 23.2899 6.19069 27.1437 8.76672 30.1281C11.3427 33.1125 14.9592 35.0031 18.8799 35.4152C22.8007 35.8273 26.7312 34.7298 29.8714 32.3463C33.0116 29.9627 35.1256 26.4722 35.783 22.585C36.4405 18.6979 35.592 14.7062 33.4104 11.4225C31.2287 8.13887 27.8777 5.8099 24.0395 4.90965C20.3639 4.04753 16.5059 4.55774 13.1872 6.3337C12.9437 6.46399 12.6382 6.38286 12.5001 6.14372C12.3621 5.90457 12.4437 5.59802 12.6869 5.46725C16.2261 3.56438 20.3446 3.01587 24.2679 3.93607C28.3537 4.8944 31.9209 7.37362 34.2433 10.8692C36.5657 14.3647 37.4689 18.6138 36.769 22.7518C36.0691 26.8897 33.8188 30.6055 30.476 33.1428C27.1332 35.6802 22.9491 36.8484 18.7754 36.4097C14.6017 35.971 10.7519 33.9584 8.00972 30.7815C5.2675 27.6046 3.83888 23.5022 4.01462 19.3091C4.18337 15.2829 5.8192 11.4637 8.60374 8.56657C8.79509 8.36748 9.11231 8.37126 9.30552 8.56856C9.49873 8.76585 9.49471 9.08192 9.30375 9.28139C6.70074 12.0003 5.17184 15.5789 5.01374 19.351Z",
    fill: "#1B1B1B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5 14L20.5 22",
    stroke: "#59BD39",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5 25V26",
    stroke: "#59BD39",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_682_671"
  }, /*#__PURE__*/React.createElement("rect", {
    width: "1em",
    height: "1em",
    fill: "white",
    transform: "translate(0.5)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgEmpty);
export default ForwardRef;